import React, { useEffect, useState } from 'react';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import closeWhiteSvg from '../../styles/assets/close_white.svg';
import infoWhiteSvg from '../../styles/assets/info.svg';


const useStyles = makeStyles(theme => ({
  errorToastContainer: {
    position: 'fixed',
    top: 0,
    zIndex: 100000,
    padding: '10px 12px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontFamily: 'Montserrat',
    color: '#ffffff',
    background: '#181818',

    width: '100%',
    margin: 0,
    [theme.breakpoints.up('768')]: {
      width: 'calc(100% - 24px)',
      margin: '0 12px',
    },
  },
  desc: {
    fontSize: 14,
    lineHeight: '18px',
  },
}));

const ReLoginToast = () => {
  const classes = useStyles();

  const [error, setError] = useState();

  useEffect(() => {
    const reLoginMessage = JSON.parse(sessionStorage.getItem('reLoginMessage') || null);
    setError(reLoginMessage);
    // setError({
    //   closeWindow: true,
    //   errorButtonText: "OK",
    //   errorCode: "405502",
    //   errorCodeText: "Error code",
    //   errorTraceID: "PH2021110823734",
    //   header: "Something is wrong",
    //   icon: "success",
    //   label: "Error 405502 23734",
    //   subHeader: "Your login has been expired. Please re-login",
    //   subType: "Error",
    //   type: "Banner",
    // });
  }, []);

  return (
    <>
      {
      error ? (
        <Box className={classes.errorToastContainer}>
          <Box><img src={infoWhiteSvg} alt="info" /></Box>
          <Box textAlign="center">
            <Box className={classes.desc}>{error.subHeader}</Box>
          </Box>
          <Box
            style={{
              cursor: 'pointer',
            }}
            onClick={
              () => {
                setError(null);
                sessionStorage.removeItem('reLoginMessage');
              }
            }
          >
            <img src={closeWhiteSvg} alt="close" />
          </Box>
        </Box>
      ) : null
    }
    </>
  );
};

export default ReLoginToast;
